"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const RowSelector_1 = require("../components/RowSelector");
const typings_1 = require("../typings");
const useRowSelection = (hooks) => {
    hooks.allColumns.push((columns, { instance }) => [
        {
            id: typings_1.RowSelectionId,
            minWidth: 45,
            width: 45,
            maxWidth: 45,
            /* eslint-disable react/display-name, react/prop-types */
            Header: ({ getToggleAllPageRowsSelectedProps, getToggleAllRowsSelectedProps, maxSelectedRows, state, page, rows }) => {
                const _a = (instance.page != null
                    ? getToggleAllPageRowsSelectedProps
                    : getToggleAllRowsSelectedProps)(), { checked, indeterminate } = _a, rest = __rest(_a, ["checked", "indeterminate"]);
                const { selectedRowIds = {} } = state;
                const numSelectedRowsOnPage = (page != null ? page : rows).filter((r) => r.isSelected).length;
                const totalSelectedRows = Object.keys(selectedRowIds).length;
                const numSelectableRows = (page != null ? page : rows).length;
                const disableSelectAll = (!checked || indeterminate) && maxSelectedRows != null
                    ? numSelectableRows - numSelectedRowsOnPage >
                        maxSelectedRows - totalSelectedRows
                    : false;
                return (react_1.default.createElement(RowSelector_1.AllRowSelector, Object.assign({}, rest, { checked: checked, indeterminate: indeterminate, disabled: disableSelectAll })));
            },
            Cell: ({ row, maxSelectedRows, state }) => {
                const _a = row.getToggleRowSelectedProps(), { checked } = _a, rest = __rest(_a, ["checked"]);
                const { selectedRowIds = {} } = state;
                const numSelectedRows = Object.keys(selectedRowIds).length;
                const disableSelect = !checked && maxSelectedRows != null
                    ? maxSelectedRows - numSelectedRows <= 0
                    : false;
                return (react_1.default.createElement(RowSelector_1.RowSelector, Object.assign({}, rest, { checked: checked, disabled: disableSelect })));
            },
            /* eslint-enable react/display-name, react/prop-types */
            disableFilters: true,
            disableSortBy: true,
            disableGroupBy: true,
            disableResizing: true
        },
        ...columns
    ]);
};
exports.default = useRowSelection;
//# sourceMappingURL=useRowSelection.js.map